function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("polygon", {
  className: "st0",
  points: "49.1,83.8 62.5,83.8 55.7,58  "
}), React.createElement("path", {
  className: "st0",
  d: "M114.7,26.3h-80c-4.8,0-8.6,3.9-8.6,8.6v81.9c0,4.8,3.9,8.6,8.6,8.6h80c4.8,0,8.6-3.9,8.6-8.6V35 C123.3,30.2,119.5,26.3,114.7,26.3z M70,111.4l-4.3-15.8H46L42,111.4H31.5l19.1-69.7h10.5l19.7,69.7H70z M119.8,53.5H96V70h20.5 v11.8H96v29.6h-9.9V41.7h33.7V53.5z"
}));

var SvgAutoFocusIcon = function SvgAutoFocusIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAutoFocusIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/auto-focus-icon.6ae4c778.svg";
export { ForwardRef as ReactComponent };